import { render, staticRenderFns } from "./ca.vue?vue&type=template&id=63ebbfa2&scoped=true&"
import script from "./ca.vue?vue&type=script&lang=js&"
export * from "./ca.vue?vue&type=script&lang=js&"
import style0 from "./ca.vue?vue&type=style&index=0&id=63ebbfa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebbfa2",
  null
  
)

export default component.exports